import React, { Component } from 'react';

import Header from "../Header/Header"
import Welcome from "../Welcome/Welcome"
import Item from "../Item/Item"
import Timeline from "../Timeline/Timeline"
import Video from "../Video/Video"
import MustKnow from "../MustKnow/MustKnow"
import FooterBanner from "../FooterBanner/FooterBanner"
import Footer from "../Footer/Footer"

class App extends Component {
  render() {
    return (
      <div className="App-Nespresso">
      <Header />
      <Welcome />
      <Item item={0} />
      <Timeline />
      <Video />
      <Item item={1} />
      <MustKnow />
      <FooterBanner />
      <Footer />      
      </div>
    );
  }
}

export default App;
/*

https://z.ynet.co.il/short/commerce/2018/nespresso/
https://z.ynet.co.il/short/commerce/2018/nespresso
http://z.ynet.co.il/short/commerce/2018/nespresso/
http://z.ynet.co.il/short/commerce/2018/nespresso

https://z.ynet.co.il/short/commerce/2018/nespresso/static/css/main.615e1456.css
https://z.ynet.co.il/short/commerce/2018/nespresso/static/js/main.bb313810.js

http://z.ynet.co.il/short/commerce/2018/nespresso/static/css/main.615e1456.css
http://z.ynet.co.il/short/commerce/2018/nespresso/static/js/main.bb313810.js


*/


// WEBPACK FOOTER //
// ./src/Components/App/App.js